import { Controller } from "@hotwired/stimulus"
import { csrfToken } from "../lib/utils.js"

const COOKIE_NAME = "cookie_consent"
const COOKIE_MAX_AGE = 365 * 24 * 60 * 60 // 1 year in seconds

export default class extends Controller {
  static values = { url: String }

  connect() {
    if (this.#gpcEnabled()) {
      this.#setConsent("declined")
      this.#recordConsent(false)
      return
    }

    if (!this.#hasConsent()) {
      this.element.classList.remove("hidden")
    }
  }

  accept() {
    this.#setConsent("accepted")
    this.element.classList.add("hidden")
    this.#recordConsent(true)
    document.dispatchEvent(new CustomEvent("cookie-consent:accepted"))
  }

  decline() {
    this.#setConsent("declined")
    this.element.classList.add("hidden")
    this.#recordConsent(false)
  }

  // Called from the "Cookie Preferences" footer link
  reset() {
    document.cookie = `${COOKIE_NAME}=; max-age=0; path=/`
    this.element.classList.remove("hidden")
  }

  #hasConsent() {
    return document.cookie.split("; ").some(c => c.startsWith(`${COOKIE_NAME}=`))
  }

  #gpcEnabled() {
    return navigator.globalPrivacyControl === true
  }

  #setConsent(value) {
    document.cookie = `${COOKIE_NAME}=${value}; max-age=${COOKIE_MAX_AGE}; path=/; SameSite=Lax`
  }

  #recordConsent(granted) {
    if (!this.hasUrlValue) return
    fetch(this.urlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken()
      },
      body: JSON.stringify({ granted }),
      keepalive: true
    })
  }
}
